export default {
  云招商: '云招商',
  最近成功找到加盟商: '最近成功找到加盟商',
  火热招商中: '火热招商中',
  招商中: '招商中',
  招商名称: '招商名称',
  更多云招商推荐: '更多云招商推荐',
  招商品牌: '招商品牌',
  招商类型: '招商类型',
  已加盟数: '已加盟数',
  招商流程: '招商流程',
  最低投资金额: '最低投资金额',
  服务支持: '服务支持',
  招商对象: '招商对象',
  招商地区: '招商地区',
  '全国(中国)': '全国(中国)',
  我要加盟: '我要加盟',
  招商详细介绍: '招商详细介绍',
  招商支持: '招商支持',
  招商视频: '招商视频',
  招商图片: '招商图片',
  招商品牌logo: '招商品牌logo',
  招商编号: '招商编号',
  最近发布时间: '最近发布时间',
  加盟人数: '加盟人数',
}
